/**
 * Pure helpers for the OAuth Settings page.
 */

import type { OAuthConnection } from './types';

export const isAuthProvider = (provider: string): boolean => {
  return ['google', 'github', 'gitlab'].includes(provider);
};

export const isRepositoryProvider = (provider: string): boolean => {
  return ['github', 'gitlab', 'bitbucket'].includes(provider);
};

export const getInitials = (name: string): string => {
  if (!name) return '??';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    // Single word: use first and last letter
    return parts[0].length > 1
      ? (parts[0][0] + parts[0][parts[0].length - 1]).toUpperCase()
      : parts[0][0].toUpperCase();
  }
  // Multiple words: use first letter of first and last word
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const connectionNeedsRepoScope = (connection: OAuthConnection): boolean => {
  return connection.provider === 'github' && !connection.scopes.some((scope) => scope === 'repo');
};

export const connectionNeedsAppInstallation = (connection: OAuthConnection): boolean => {
  return (
    connection.provider === 'github' &&
    connection.appInstallation?.configured === true &&
    connection.appInstallation?.needsInstallation === true
  );
};
